import axios from 'axios';
import {Toast} from 'vant'
import { i18n } from './lang'

console.log(process.env.NODE_ENV);
const baseURL = process.env.NODE_ENV === 'production' ? 'cloud.cages.cn' : 'shinetechzz.tpddns.cn:30226';
axios.defaults.crossDomain = true;

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

//axios拦截器，目的是为了在请求头上带上token
axios.interceptors.request.use(
    config => {
        console.log(config);
        config.url = `https://${baseURL}/sites/api/index.php?url=${config.url}`;
        if (localStorage.getItem('Authorization')) {
            config.headers.common["Authorization"] = localStorage.getItem('Authorization');
        }
        return config;
    },
    error => {
        // console.log(error)
        return Promise.reject(error);
    });

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    console.log(response)
    // 对响应数据做点什么
    if (response.data && response.data.succeed !== 1) {
        let message = i18n.t(`errors.${response.data.error_code}`) || '未知错误';
        if (typeof message === 'string' && message.indexOf('errors.') >= 0) {
            message = response.data.error_desc;
        }
        Toast.fail(message);
        return Promise.reject(response);
    }
    return response.data
}, function (error) {
    // 对响应错误做点什么
    // console.log('--- 401 res error response ---')
    // console.log(error.response)
    // if(error && error.response && error.response.status == '401') {
    //
    // }
    return Promise.reject(error)
})
